import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

const stats = [
    { value: 18, suffix: "+", label: "Years offshore only" },
    { value: 240, suffix: "", label: "Platforms & vessels serviced" },
    { value: 99.6, suffix: "%", label: "System uptime maintained" },
    { value: 24, suffix: "/7", label: "Offshore dispatch cover" },
];

function Counter({ value, suffix }) {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-60px" });
    const [n, setN] = useState(0);

    useEffect(() => {
        if (!inView) return;
        const isFloat = !Number.isInteger(value);
        const duration = 1400;
        const start = performance.now();
        let raf;
        const tick = (t) => {
            const p = Math.min(1, (t - start) / duration);
            const eased = 1 - Math.pow(1 - p, 3);
            setN(isFloat ? +(value * eased).toFixed(1) : Math.round(value * eased));
            if (p < 1) raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf);
    }, [inView, value]);

    return (
        <span ref={ref}>
            {n}
            {suffix}
        </span>
    );
}

export default function Stats() {
    return (
        <section id="stats" data-testid="stats-section" className="bg-abyss py-20 lg:py-24">
            <div className="mx-auto max-w-[1400px] px-6 lg:px-10 grid grid-cols-2 lg:grid-cols-4 border-l border-t border-border">
                {stats.map((s) => (
                    <div key={s.label} className="border-r border-b border-border p-8 lg:p-10">
                        <div className="font-heading font-black tracking-tighter text-5xl lg:text-6xl text-foreground">
                            <Counter value={s.value} suffix={s.suffix} />
                        </div>
                        <p className="mt-3 font-mono-tech text-[11px] uppercase tracking-[0.2em] text-steel">
                            {s.label}
                        </p>
                    </div>
                ))}
            </div>
        </section>
    );
}
